<template>
    <Descriptions
        bordered
        :column="2"
    >
        <DescriptionsItem
            :span="2"
            :label="$t('name')"
        >
            {{ measure.name }}
        </DescriptionsItem>
        <DescriptionsItem
            :span="2"
            :label="$t('abbreviation')"
        >
            {{ measure.abbreviation }}
        </DescriptionsItem>
        <DescriptionsItem
            :span="2"
            :label="$t('status')"
        >
            {{ $t(measure.status) }}
        </DescriptionsItem>
        <DescriptionsItem
            :span="2"
            :label="$t('description')"
        >
            {{ measure.description }}
        </DescriptionsItem>
        <DescriptionsItem :label="$t('domain')">
            {{ measure.domain }}
        </DescriptionsItem>
        <DescriptionsItem
            :label="$t('type')"
        >
            {{ measure.type }}
        </DescriptionsItem>
        <DescriptionsItem :label="$t('system')">
            {{ measure.system }}
        </DescriptionsItem>
    </Descriptions>
</template>

<script>
import { Descriptions } from 'ant-design-vue';
export default {
    name: 'General',
    components: {
        Descriptions,
        DescriptionsItem: Descriptions.Item,
    },
    props: {
        measure: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>

</style>